import { mapState } from "vuex";
export default {
    filters: {
        formatDate: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('MMM DD YYYY, hh:mm A') : '';
        },
        formatYear: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('YYYY') : '';
        },
        formatMonth: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('MMMM') : '';
        },
        formatShortMonth: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('MMM') : '';
        },
        formatDay: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('DD') : '';
        },
        formatTime: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('LT') : '';
        },
        formatAppDate: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('ll').replace(/^\w/, c => c.toUpperCase()) : '';
        },
        formatDateLog: function(dateValue, timezoneHelper) { //Assuming that format date input is YYYY-MM-DD HH:mm:ss adds .000Z to consider it as server date
            return dateValue ? timezoneHelper.toMoment(`${dateValue}.000Z`, timezoneHelper.timeZone).format('MMM D, YYYY H:mm') : '';
        },
        formatDateTime: function(dateValue, timezoneHelper) {
            let locale = moment.locale('es') ? 'DD MMM YYYY' : 'MMM DD YYYY';
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format(locale) : '';
        },
        formatDateApp: function(dateValue, timezoneHelper) {
            return dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone).format('LLLL') : '';
        },
        formatTimezone: function(dateValue, timezoneHelper) {
            let data = dateValue ? timezoneHelper.toMoment(dateValue, timezoneHelper.timeZone) : '';
            return data ? data.tz() === 'America/Whitehorse' ? data.tz() + ' YT' : data.tz() + ' ' + data.format('z Z') : '';
        },
        formatDateShort: function(dateValue, tzHelper) {
            if (!dateValue) {
                return '';
            }
            // Check if tzHelper and its necessary components are valid
            if (tzHelper && typeof tzHelper.toMoment === 'function' && typeof tzHelper.timeZone !== 'undefined') {
                try {
                    return tzHelper.toMoment(dateValue, tzHelper.timeZone).format('LL');
                } catch (e) {
                    console.warn('Error using timezoneHelper in formatDateShort, falling back:', e);
                    // Fallback for safety, assuming moment is globally available or imported in the execution scope of filters
                    // This may not have the correct timezone but prevents a crash.
                    try {
                        return moment(String(dateValue)).format('LL');
                    } catch (momentError) {
                        console.error('Fallback moment formatting failed in formatDateShort:', momentError);
                        return String(dateValue); // Ultimate fallback
                    }
                }
            } else {
                console.warn('Invalid timezoneHelper passed to formatDateShort, falling back.');
                 try {
                    return moment(String(dateValue)).format('LL');
                } catch (momentError) {
                    console.error('Fallback moment formatting failed in formatDateShort due to invalid helper:', momentError);
                    return String(dateValue); // Ultimate fallback
                }
            }
        },
    },
    computed: {
        ...mapState(['corporation', 'corporationInfo']),
        currentTimezone() {
            return this.corporationInfo ? this.corporationInfo.timezone||moment.tz.guess() : moment.tz.guess();
        },
        serverTimezone() {
            return this.corporation ? this.corporation.serverTimezone : this.currentTimezone;
        },
        domainTimezone() {
            return this.corporationInfo ? this.corporationInfo.timezone||moment.tz.guess() : this.serverTimezone;
        },
    },
    methods: {
        timeZone(course) {
            return course.timezone||this.domainTimezone;
        },
        toMoment(dateValue, timeZone) {
            return moment.tz(String(dateValue), [`${moment.HTML5_FMT.DATE} ${moment.HTML5_FMT.TIME_SECONDS}`,
                                                moment.HTML5_FMT.DATETIME_LOCAL,
                                                moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
                                                moment.HTML5_FMT.DATETIME_LOCAL_MS], `${dateValue}`.includes('Z') && !`${dateValue}`.includes('00:00:00.000Z') ? this.serverTimezone: this.currentTimezone).tz(timeZone);
        },
        timezoneHelper(course) {
            return {
                timeZone: this.timeZone(course),
                toMoment: this.toMoment,
            };
        },
        mergeDateTime(dateValue, timeValue) {
            if(!dateValue && !timeValue) return;
            const dateData = (dateValue||moment().startOf('day').format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)).split(/T|\s/);
            const timeData = (timeValue||dateData[1]);
            return `${dateData[0]}T${timeData}`;
        },
    },
}